import ProgressIndicator from '~/components/ProgressIndicator';
import Typography from '~/components/Typography';
import type { Publication } from '~/interfaces/publication';

interface Props {
  progress?: number;
  redirects?: string[];
  currentStep?: any;
  publication: Publication;
}

const SignupFlowNav = ({ redirects, currentStep, progress = 0, publication }: Props) => {
  const successMessage = publication.web_template.signup_flow_messaging.success_message;
  const stepMessage = currentStep?.page_message;
  const hasMultipleRedirects = redirects && redirects?.length > 1;

  return (
    <>
      <div className="fixed z-20 flex h-14 w-full justify-center bg-white shadow-lg">
        <div className="overflow-hidden rounded-full bg-white">
          <img
            className="absolute left-1/2 top-7 z-10 h-14 w-14 -translate-x-1/2 transform rounded-full"
            src={publication.web_template.signup_flow_avatar_url}
            alt="avatar"
          />
        </div>
        {hasMultipleRedirects && (
          <div className="absolute top-14 w-full">
            <ProgressIndicator currentProgress={progress} variant="signup-flow" />
          </div>
        )}
      </div>
      <div>
        <div className="mb-2 h-14" />
        <div className="mx-auto flex w-full max-w-xl flex-col items-center space-y-2 pb-4 pt-8 text-center">
          {successMessage && (
            <Typography as="p" size={'sm'} className="font-medium">
              {publication.web_template.signup_flow_messaging.success_message}
            </Typography>
          )}
          {stepMessage && (
            <Typography as="h4" size={'xl'} weight="semibold">
              {currentStep?.page_message}
            </Typography>
          )}
        </div>
      </div>
    </>
  );
};

export default SignupFlowNav;
